<template>
    <div class="pdf-embeder" ref="container"></div>
</template>

<script>
    import * as pdfjs from 'pdfjs-dist'
    import { PDFPageView, EventBus } from 'pdfjs-dist/web/pdf_viewer.js'
    pdfjs.GlobalWorkerOptions.workerSrc = '/front/js/pdf.worker.min.js'

    export default {
        props: {
            src: {
                type: String,
                default: ''
            },
            printing: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                views: [],
                resizeId: null,
                observer: null
            }
        },
        mounted() {
            console.log('123')
            window.addEventListener('resize', this.resize)
            if ('IntersectionObserver' in window) {
                this.observer = this._observer()
                this.observer.observe(this.$el)
            }
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.resize)
            if (this.observer) {
                this.observer.unobserve(this.$el)
            }
            this.destroy()
        },
        watch: {
            src: {
                immediate: true,
                handler(val, old) {
                    if (val != old && val && val.length > 0) {
                        this.load()
                    }
                }
            }
        },
        methods: {
            _observer() {
                return new IntersectionObserver(
                    entries => {
                        entries.forEach(entry => {
                            if (!this.printing && (entry.isIntersecting || entry.intersectionRatio > 0)) {
                                this.rescale()
                            }
                        })
                    },
                    { rootMargin: '0px', threshold: 0 }
                )
            },
            load() {
                this.views.forEach(view => {
                    view.destroy()
                })
                this.views = []
                if (this.$refs.container) {
                    this.$refs.container.innerHTML = ''
                }
                let eventBus = new EventBus()
                let pageNum = 1
                const task = pdfjs.getDocument(this.src)
                task.promise.then(doc => {
                    Promise.resolve().then(() => {
                        for (var num = 1; num <= doc.numPages; num++) {
                            doc.getPage(num).then(page => {
                                let w = this.$refs.container ? this.$refs.container.offsetWidth : 0
                                let scale = w ? w / (page.getViewport({ scale: 1.0 }).width * (96 / 72)) : 1.25
                                let view = new PDFPageView({
                                    id: pageNum,
                                    scale: scale,
                                    container: this.$refs.container,
                                    defaultViewport: page.getViewport({ scale: scale }),
                                    eventBus: eventBus
                                })
                                pageNum += 1
                                view.setPdfPage(page)
                                if (this.printing) {
                                    view.update({
                                        scale: 1.25
                                    })
                                }
                                this.views.push(view)
                                view.draw()
                            })
                        }
                    })
                })
            },
            rescale() {
                if (this.views.length > 0) {
                    if (this.printing) {
                        this.views.forEach(view => {
                            view.update({
                                scale: 1.25
                            })
                            view.draw()
                        })
                    } else {
                        this.views.forEach(view => {
                            let scale =
                                this.$refs.container.offsetWidth /
                                (view.pdfPage.getViewport({ scale: 1.0 }).width * (96 / 72))
                            if (view.scale != scale) {
                                view.update({
                                    scale
                                })
                                view.draw()
                            }
                        })
                    }
                }
            },
            resize() {
                if (!this.printing) {
                    clearTimeout(this.resizeId)
                    this.resizeId = setTimeout(this.rescale, 200)
                }
            },
            destroy() {
                this.views.forEach(view => {
                    view.destroy()
                })
                this.views = []
                clearTimeout(this.resizeId)
                this.resizeId = null
                this.$refs.container.innerHTML = ''
                this.observer = null
            }
        }
    }
</script>
